import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		paper: ({ theme }: { theme: Theme }) => ({
			maxWidth: 'min(1150px,95%)',
			width: '100%',
			boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)',
			border: '3px solid transparent',
			borderRadius: '20px',
			padding: '24px',
			gap: '6px',
			background: theme.palette.modal.modalGradient,
			'&::-webkit-scrollbar': {
				width: '4px',
			},
			'&::-webkit-scrollbar-track': {
				boxShadow: 'inset 0 0 6px rgba(0,0,0,0.1)',
				borderRadius: '10px',
				display: 'block',
				marginBlock: '10px',
			},
			'&::-webkit-scrollbar-thumb': {
				backgroundColor: '#888',
				borderRadius: '10px',
			},
			'&::-webkit-scrollbar-thumb:hover': {
				backgroundColor: '#555',
			},
			[theme.breakpoints.down('sm')]: {
				padding: '16px 8px',
				margin: '16px',
				gap: '8px',
				border: '1px solid transparent',
				borderRadius: '16px',
			},
		}),
		root: {},
		container: {
			backdropFilter: 'blur(10px)',
		},
	},
};
